import React from "react";
import "./LearningDetectedTag.css";

const LearningDetectedTag = ({ count, onClick }) => {
  if (!count || count <= 0) return null;

  return (
    <button
      type="button"
      className="learning-detected-tag"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      title="View detected learnings in PABS"
    >
      <span className="learning-detected-tag__dot" />
      {count} learning{count !== 1 ? "s" : ""} detected
    </button>
  );
};

export default LearningDetectedTag;
